import { InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError, errorHandler, ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards, Req } from '@nestjs/common';
import { ProdInvDTO } from './dto/prod-inv.dto';
import { AllLotCodeOpsResponseModel, AllProdInvResponseModel, LotCodeDropDownResponse, LotCodeOpsResponseModel, OperationandLotReq, ProdInvResponseModel } from '@gtpl/shared-models/production-management';
import { ProdInvRequest } from './dto/prod-inv-request';
import { LotCodeOpsService } from './lot-code-ops.service';
import { LotCodeOpsDTO } from './dto/lot-code.dto';
import { UnitRequest } from '@gtpl/shared-models/common-models';
import { SoSoItemRequest } from './dto/lot-no-for-so.request';
import { SaleOrderItemsDropdownResponse, SoNumbersResponseModel } from '@gtpl/shared-models/sale-management';
import { SoIdRequest } from './dto/so-id.request';
import { CommonResponse } from '@gtpl/shared-models/masters';


@ApiTags('lot-code-ops')
@Controller('lot-code-ops')
export class LotCodeOpsController {
  constructor(
    private lotCodeOpsService: LotCodeOpsService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler
  ) { }

  @Post('/createLotCodeOps')
  async createLotCodeOps(@Body() lotCodeOpsDto: LotCodeOpsDTO, isUpdate: boolean = false): Promise<LotCodeOpsResponseModel> {
    try {
      return await this.lotCodeOpsService.createLotCodeOps(lotCodeOpsDto, false);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(LotCodeOpsResponseModel, error);
    }
  }

  @Post('/updateLotCodeOps')
  async updateLotCodeOps(@Body() lotCodeOpsDto: LotCodeOpsDTO, @Req() request: Request): Promise<LotCodeOpsResponseModel> {
    try {
      console.log('update LotCodeOps');
      console.log(request);
      return await this.lotCodeOpsService.createLotCodeOps(lotCodeOpsDto, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(LotCodeOpsResponseModel, error);
    }
  }

  @Post('/getAllLotOps')
  // @UseGuards(AuthGuard('jwt'))
  async getAllLotOps(@Body() plantReq: UnitRequest): Promise<AllLotCodeOpsResponseModel> {
    try {
      return await this.lotCodeOpsService.getAllLotOps(plantReq.unitId);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllLotCodeOpsResponseModel, error);
    }
  }

  @Post('/getSaleOrders')
  async getSaleOrders(): Promise<SoNumbersResponseModel> {
    try {
      return await this.lotCodeOpsService.getSaleOrders();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SoNumbersResponseModel, error);
    }
  }

  @Post('/getSaleOrderItemsForSo')
  async getSaleOrderItemsForSo(@Body() req: SoIdRequest): Promise<SaleOrderItemsDropdownResponse> {
    try {
      return await this.lotCodeOpsService.getSaleOrderItemsForSo(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderItemsDropdownResponse, error);
    }
  }

  @Post('/getAllLotNumbers')
  async getAllLotNumbers(@Body() req?: UnitRequest): Promise<LotCodeDropDownResponse> {
    try {
      return await this.lotCodeOpsService.getAllLotNumbers(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(LotCodeDropDownResponse, error);
    }
  }

  @Post('/getAllLotNumbersForSoItem')
  async getAllLotNumbersForSoItem(@Body() req: SoSoItemRequest): Promise<LotCodeDropDownResponse> {
    try {
      return await this.lotCodeOpsService.getAllLotNumbersForSoItem(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(LotCodeDropDownResponse, error);
    }
  }
  @Post('/getSonumberforQaQcrejection')
  async getSonumberforQaQcrejection(@Body() req:OperationandLotReq): Promise<CommonResponse> {
    try {
      return await this.lotCodeOpsService.getSonumberforQaQcrejection(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

}
